// src/services/api.ts
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';

export async function apiGet<T>(path: string, signal?: AbortSignal): Promise<T> {
  const url = `${API_BASE_URL}${path}`;

  const res = await fetch(url, { method: 'GET', signal });
  // Si el backend manda 200 + [], esto funciona sin drama.
  // Si manda 4xx/5xx, intentamos leer message y lanzamos error decente.
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try {
      const body = await res.json();
      if (body?.message) msg = body.message;
    } catch {
      // si no hay body o no es JSON, nos quedamos con HTTP status
    }
    throw new Error(msg);
  }

  // Importante: si algún día vuelves a usar 204, aquí truena.
  // Pero dijimos 200 + [], así que ok.
  return (await res.json()) as T;
}
